import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const PackageAssociationContext = createContext(null);

export const PackageAssociationProvider = ({ items, entity, children }) => {
    const [checkList, setCheckList] = useState([]);

    useEffect(() => {
        setCheckList(
            (items || []).map((item) => ({
                ...item,
                checked: Boolean(item.checked ?? item.selected),
            })),
        );
    }, [items, entity]);

    const originalCheckedList = useMemo(
        () =>
            JSON.stringify(
                (items || [])
                    .filter((item) => item.checked ?? item.selected)
                    .map((item) => ({ id: item.id })),
            ),
        [items, entity],
    );

    const currentCheckedList = useMemo(
        () =>
            JSON.stringify(
                checkList.filter((item) => item.checked).map((item) => ({ id: item.id })),
            ),
        [checkList],
    );

    const hasChanges =
        Boolean(originalCheckedList) &&
        Boolean(currentCheckedList) &&
        originalCheckedList !== currentCheckedList;

    const isChecked = (id) =>
        Boolean(checkList.find((item) => String(item.id) === String(id))?.checked);

    const toggleItem = (id) => {
        setCheckList((prev) =>
            prev.map((item) =>
                String(item.id) === String(id) ? { ...item, checked: !item.checked } : item,
            ),
        );
    };

    const resetCheckList = () => {
        setCheckList(
            (items || []).map((item) => ({
                ...item,
                checked: Boolean(item.checked ?? item.selected),
            })),
        );
    };

    return (
        <PackageAssociationContext.Provider
            value={{
                checkList,
                hasChanges,
                isChecked,
                toggleItem,
                resetCheckList,
                setCheckList,
            }}
        >
            {children}
        </PackageAssociationContext.Provider>
    );
};

export const usePackageAssociation = () => {
    const context = useContext(PackageAssociationContext);
    if (!context) {
        throw new Error("usePackageAssociation must be used within PackageAssociationProvider");
    }
    return context;
};
